export default "__VITE_ASSET__DIaQwUie__"